import { Route, useRouteMatch } from "react-router-dom";

import { TestAnalysisProvider } from "../../contexts/test-analysis.context";

import TestAnalysisSummary from "./test-analysis-summary.component";
import TestAnalysisDetail from "./test-analysis-detail.component";

import "./test-analysis.styles.css";

const TestAnalysis = () => {
  const match = useRouteMatch();

  return (
    <TestAnalysisProvider>
      <Route path={match.path} exact={true} component={TestAnalysisSummary} />
      <Route
        path={`${match.path}/:categoryId`}
        exact={true}
        component={TestAnalysisDetail}
      />
    </TestAnalysisProvider>
  );
};

export default TestAnalysis;
